(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('ProductionUnitDetailController', function($scope, $rootScope, $stateParams, entity, ProductionUnit) {
            $scope.productionUnit = entity;
            $scope.load = function(id) {
                ProductionUnit.get({ id: id }, function(result) {
                    $scope.productionUnit = result;
                });
            };
            var unsubscribe = $rootScope.$on('remitEventsApp:productionUnitUpdate', function(event, result) {
                $scope.productionUnit = result;
            });
            $scope.$on('$destroy', unsubscribe);
        });
})();
